import React from "react";

import Layout from "../../components/layout";
import SEO from "../../components/SEO";
import { BlankAuctionHouseProjectSection } from "../../containers/projects";

const BlankAuctionHouseProjectPage = () => {
  return (
    <Layout>
      <SEO
        title="Blank Auction House - Projects"
        description="Frontend for Blank Studio's NFT auction marketplace | Web3, E-Commerce | Year: 2022 | Javascript, React, Next.js, Chakra UI, Framer Motion"
      />
      <BlankAuctionHouseProjectSection />
    </Layout>
  );
};

export default BlankAuctionHouseProjectPage;
